import {IComponentOptions, IFilterService, ILogService, IPromise} from 'angular';
import TSBenutzer from '../../../models/TSBenutzer';
import TSDownloadFile from '../../../models/TSDownloadFile';
import TSZahlungsauftraegeSearchresultDTO from '../../../models/TSZahlungsauftraegeSearchresultDTO';
import TSZahlungsauftragDTO from '../../../models/TSZahlungsauftragDTO';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import ErrorService from '../../errors/service/ErrorService';
import BeitragRS from '../../service/BeitragRS';
import {DownloadRS} from '../../service/downloadRS.rest';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;
import ITranslateService = angular.translate.ITranslateService;
let template = require('./dv-zahlungsauftrag-list.html');
require('./dv-zahlungsauftrag-list.scss');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVZahlungsauftragListConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        onFilterChange: '&',
        tabindex: '@',
        selectedtab: '=',
        moeglicheBesitzer: '<',
    };
    template = template;
    controller = DVZahlungsauftragListController;
    controllerAs = 'vm';
}

export class DVZahlungsauftragListController {

    moeglicheBesitzer: Array<TSBenutzer>;
    moeglicheBesitzerForFilter: Array<TSBenutzer> = [];
    selectedBesitzer: string;

    displayedCollection: Array<TSZahlungsauftragDTO> = []; //Liste die im Gui angezeigt wird
    pagination: any;

    onFilterChange: (changedTableState: any) => IPromise<any>;
    tableFilterState: any;

    tabindex: string;
    selectedtab: number; // indexID der aktuellen Schadenfalltabelle (es gibt mehrere)
    defaultTableFilterState: any = {
        sort: {},
        search: {},
        pagination: {start: 0, totalItemCount: 0, number: 30}
    };

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', '$window', '$translate', 'BeitragRS', 'DvDialog', 'ErrorService', 'DownloadRS'];
    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private $window: IWindowService,
                private $translate: ITranslateService, private beitragRS: BeitragRS, private dvDialog: DvDialog,
                private errorService: ErrorService, private downloadRS: DownloadRS) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

        if (this.moeglicheBesitzer === undefined || this.moeglicheBesitzer === null) {
            this.$log.debug('list of moeglicheBesitzer is empty');
            this.moeglicheBesitzer = [];
        }
        // this creates a dummy element for the filter header; this could be done using ng-repeat on the option element but that is slow in ie.
        if (this.moeglicheBesitzer) {
            angular.copy(this.moeglicheBesitzer, this.moeglicheBesitzerForFilter);
        }

    }

    private callServer = (tableFilterState: any) => {
        this.tableFilterState = tableFilterState;
        //wenn aktuelles tab nicht gewaehltes ist machen wir nichts
        if (this.selectedtab !== parseInt(this.tabindex)) {
            return;
        }

        this.pagination = tableFilterState.pagination;

        if (this.onFilterChange && angular.isFunction(this.onFilterChange)) {
            this.onFilterChange({
                tableState: tableFilterState
            }).then((result: TSZahlungsauftraegeSearchresultDTO) => {
                if (result) {
                    tableFilterState.pagination.totalItemCount = result.totalResultSize;
                    tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                    this.displayedCollection = new Array<TSZahlungsauftragDTO>().concat(result.zahlungsauftragDTOs);
                }
            });
        } else {
            this.$log.info('no callback function spcified for filtering');
        }
    };

    public getColumnsNumber(): number {
        let element = angular.element('.dv-zahlungsauftrag-list.' + this.getClass() + ' .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 7;
    }

    public getClass(): string {
        return 'tab-nr-' + this.tabindex;
    }

    public downloadIso(dokumentId: string) {
        let attachment: boolean = true;
        this.$log.debug('download dokument with id ' + dokumentId);
        let win: Window = this.downloadRS.prepareDownloadWindow();

        this.downloadRS.getAccessTokenDocumentById(dokumentId).then((downloadFile: TSDownloadFile) => {
            this.$log.debug('accessToken: ' + downloadFile.accessToken);
            this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, attachment, win);
        });
    }

    public downloadExcel(dokumentId: string) {
        this.$log.debug('download dokument with id ' + dokumentId);
        let win: Window = this.downloadRS.prepareDownloadWindow();

        this.downloadRS.getAccessTokenDocumentById(dokumentId).then((downloadFile: TSDownloadFile) => {
            this.$log.debug('accessToken: ' + downloadFile.accessToken);
            this.downloadRS.startDownload(downloadFile.accessToken, downloadFile.filename, false, win);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-zahlungsauftrag-list/dv-zahlungsauftrag-list.ts